import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GridCard, GridList } from 'src/components'

import { IAccountImpactsLikes } from 'src/types'
import { LikesDashboardModal } from '../likes-dashboard'

interface IProps {
  items: IAccountImpactsLikes[]
}

export const ImpactsLikesGrid = ({ items }: IProps) => {
  const [t] = useTranslation()
  const [impactId, setImpactId] = useState<{ id: string; name: string } | null>(null)

  const handleOpenModal = (id: string, name: string) => () => {
    setImpactId({ id, name })
  }

  const handleCloseModal = () => {
    setImpactId(null)
  }

  const createItems = (id: string, name: string) => {
    return [{ title: t('view-stats-button-text.v'), onClick: handleOpenModal(id, name) }]
  }

  return (
    <>
      <GridList>
        {items?.map((props) => (
          <GridCard
            key={props.id}
            code={`${String(props.likes)} ${t('products-views-count-text.v')}`}
            image={props.image_medium || props.image}
            name={props.name}
            items={createItems(props.id, props.name)}
          />
        ))}
      </GridList>
      <LikesDashboardModal
        impactId={impactId?.id!}
        impactName={impactId?.name!}
        open={!!impactId}
        handleClose={handleCloseModal}
      />
    </>
  )
}
